import React, { useState } from 'react'
import { styled } from 'linaria/react'
import { useContext } from 'react'
import ChannelContext from '@jetshop/core/components/ChannelContext'
import {
   formatDate,
   formatISO8601Date,
   formatPrice,
} from '../../Core/Util/Helpers'
import { SiteContext } from '../../Global/SiteContext'
import { theme } from '../../Theme'
import { ProductPriceHistoryCheapest } from './ProductPriceHistoryCheapest'

import { useIntl } from '@jetshop/intl'

const ProductPriceContainer = styled.div`
   .product-details-price {
      display: flex;
      align-items: baseline;
      gap: 0.5rem;
      font-family: var(--font-industry);
   }

   .product-details-price .price {
      font-weight: 700;
      font-size: calc(0.7vw + 1.1rem);
      margin: 0;
   }

   .product-details-price .new-price {
      font-weight: 700;
      font-size: calc(0.7vw + 1.1rem);
      color: var(--color-red);
      margin: 0;
   }

   .product-details-price .new-package-price {
      font-weight: 700;
      font-size: calc(0.7vw + 1.1rem);
      margin: 0;
   }

   .product-details-price .old-price {
      font-weight: 700;
      font-size: calc(0.4vw + 0.9rem);
      text-decoration: line-through;
      margin: 0;
   }

   .product-details-price .vat {
      font-weight: 500;
      font-size: 12px;
   }

   .product-campaign {
      font-family: var(--font-industry);
      font-weight: 500;
      font-size: 12px;
      /* color: #4A4A49; */
      & > span {
         white-space: nowrap;
      }
   }
   .product-information-wrapper {
      column-gap: 0.7em;
   }
   .product-campaign-wrapper {
      min-height: 24px;
      line-height: normal;
      display: flex;
      align-items: center;
   }
`

const ProductPriceInfo = ({ product, selectedVariant }) => {
   const { showVat, productInformation } = useContext(SiteContext)
   const { selectedChannel } = useContext(ChannelContext)
   const t = useIntl()
   const isPackage = product?.isPackage ?? false
   const currentPrice = selectedVariant?.currentPrice
   const oldPrice = selectedVariant?.oldPrice
   const exVatCurrentPrice = selectedVariant?.exVatCurrentPrice
   const exVatoldPrice = selectedVariant?.exVatoldPrice
   const productOnSale = oldPrice && currentPrice < oldPrice
   const isCampaignEndDateValid = productInformation?.isCampaign

   if (!currentPrice) {
      return <></>
   }

   return (
      <ProductPriceContainer>
         {!productOnSale ? (
            <div className="product-details-price">
               <h3 className="price">
                  {showVat
                     ? formatPrice(currentPrice, selectedChannel?.id)
                     : formatPrice(exVatCurrentPrice, selectedChannel?.id)}
               </h3>{' '}
               <span className="vat">
                  {showVat ? `(${t('incl vat')})` : `(${t('excl vat')})`}
               </span>
            </div>
         ) : (
            <div className="product-details-price mb-0">
               <h3 className={!isPackage ? 'new-price' : 'new-package-price'}>
                  {showVat
                     ? formatPrice(currentPrice, selectedChannel?.id)
                     : formatPrice(exVatCurrentPrice, selectedChannel?.id)}
               </h3>{' '}
               <h3 className="old-price">
                  {showVat
                     ? formatPrice(oldPrice, selectedChannel?.id)
                     : formatPrice(exVatoldPrice, selectedChannel?.id)}
               </h3>{' '}
               <span className="vat">
                  {showVat ? `(${t('incl vat')})` : `(${t('excl vat')})`}
               </span>
            </div>
         )}
         <div className="d-flex flex-wrap product-information-wrapper">
            {isCampaignEndDateValid && productOnSale && !isPackage && (
               <div className="product-campaign-wrapper">
                  <span className="product-campaign">
                     {t("The price applies until")}
                     {' '}
                     <span>
                        {formatISO8601Date(productInformation?.campaignToDate, false, true)}
                     </span>
                  </span>
               </div>
            )}
            <div style={{ flexGrow: 1, minWidth: '200px' }}>
               {productOnSale && !isPackage && (
                  <ProductPriceHistoryCheapest
                     selectedVariant={selectedVariant}
                     showVat={showVat}
                  ></ProductPriceHistoryCheapest>
               )}
            </div>
         </div>
      </ProductPriceContainer>
   )
}

export default ProductPriceInfo
